module.exports = __webpack_public_path__ + "img/Unidad17-1.ca25d18c.png";